
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'


@Component
export default class LimitField extends Vue {
  @Prop({ default: '' }) value!: string
  @Prop({ default: '' }) name!: string
  @Prop({ default: '' }) placeholder!: string
  @Prop({ default: 15 }) maxLimit!: number
  @Prop({ default: 'text' }) type!: string
  @Prop({ default: false }) isLink!: boolean
  @Prop({ default: false }) readonly!: boolean
  @Prop({ default: () => [] }) rules!: any[]

  isShake = false

  get simpleCount() {
    if (!this.value) return 0
    return Array.from(this.value).reduce((count: number, char: string) => {
      // 判断是否为汉字（Unicode范围：\u4e00-\u9fa5）
      const isChinese = /[\u4e00-\u9fa5]/.test(char)
      return count + (isChinese ? 2 : 1)
    }, 0)
  }
  get weightedCount() {
    if (!this.value) return 0
    return Array.from(this.value).reduce((count: number, char: string) => {
      // 判断是否为汉字（Unicode范围：\u4e00-\u9fa5）
      const isChinese = /[\u4e00-\u9fa5]/.test(char)
      return count + (isChinese ? 2 : 1)
    }, 0)
  }
  get warning() {
    if (this.weightedCount > this.maxLimit) {
      return `${this.maxLimit/2}个汉字（${this.maxLimit}字符）内`
    }
    return ''
  }
    onInput(val: string) {
        this.$emit('input', val)
        this.$emit('update:modelValue', val)
    }

    focusInput() {
        // 聚焦到输入框
        (this.$refs.fieldRef as any)?.focus()
    }

    // 暴露给父组件调用的震动方法
    shake() {
        this.isShake = true
        setTimeout(() => {
            this.isShake = false
        }, 1000)
    }
}
